export const STATE_RESET = 'STATE_RESET';
export const STATE_RESET_ERR = 'STATE_RESET_ERR';